(function($) {
  $(document).ready(function() {
    var mySwiper = new Swiper('.swiper-brands', {
      // Navigation arrows
      nextButton: '.swiper-brands.swiper-button-next',
      prevButton: '.swiper-brands.swiper-button-prev',
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 30,
      loop: true,
      autoplay: 5000,
      breakpoints: {

        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
        },
        425: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
      },

    });
      var imageSwiper2 = new Swiper('.swiper-gallery-2', {
          // Navigation arrows
          nextButton: '.swiper-gallery-2.swiper-button-next',
          prevButton: '.swiper-gallery-2.swiper-button-prev',
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true
      });
    var imageSwiper = new Swiper('.swiper-gallery', {
      // Navigation arrows
      nextButton: '.swiper-gallery.swiper-button-next',
      prevButton: '.swiper-gallery.swiper-button-prev',
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true
    });
    $('img').unveil();
  });
  $(window).resize(function() {
    $('img').unveil();
  });


  //
    $('.nav-link').click(function () {
        $('body').removeClass('left-sidebar-open');
    });


    $('#megamenu-open').click(function () {
        $('.megamenu').toggleClass('open');
    });


    $(document).click(function(e) {
        var target = e.target; //target div recorded
        if (!$(target).is('.megamenu') && $(target).closest('.megamenu').length===0 && !$(target).is('#megamenu-open')) {
            $('.megamenu').removeClass('open'); //if the click element is not the above id will hide
        }
    })
    var beepOne = $("#beep-one")[0];
    $("#sound-on")
        .mouseenter(function() {
            beepOne.play();
        });




// Select all links with hashes
    $('a[href*="#"].scroll-link')
    // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - $('header').outerHeight()
                    }, 1000 );
                }
            }
        });



$(window).scroll(function() {
    if( $(this).scrollTop() > $('#start').height() ) {
        //yourNavigation.addClass(stickyDiv);
        $('header').addClass('fixed-header');
        $('body').css('padding-top',$('header').outerHeight());
    } else {
        //yourNavigation.removeClass(stickyDiv);
        $('header').removeClass('fixed-header');
        $('body').css('padding-top',0);
    }
});
/*
    $(window).scroll(function(){
        if ($(window).scrollTop() >= 95vh) {
            $('header').addClass('fixed-header');
        }
        else {
            $('header').removeClass('fixed-header');
        }
    });
*/

        // When the window has finished loading create our google map below
        google.maps.event.addDomListener(window, 'load', init);

    function init() {
        // Basic options for a simple Google Map
        // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 13,

            // The latitude and longitude to center the map (always required)
            center: new google.maps.LatLng(47.623043, 8.255099),

            // How you would like to style the map.
            // This is where you would paste any style found on Snazzy Maps.
            styles: [{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.icon","stylers":[{"color":"#6e3a35"},{"saturation":"0"},{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#efebea"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"geometry.stroke","stylers":[{"color":"#af9d94"},{"saturation":"0"},{"visibility":"off"}]},{"featureType":"landscape","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"hue":"#ff0000"},{"saturation":"34"},{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"},{"lightness":"60"},{"gamma":"1.00"},{"hue":"#ff0000"},{"saturation":"-90"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"saturation":"0"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"simplified"},{"hue":"#ff0000"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"geometry.fill","stylers":[{"color":"#bfb1a9"},{"saturation":"0"}]},{"featureType":"transit","elementType":"geometry.stroke","stylers":[{"color":"#bfb1a9"},{"saturation":"0"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"on"},{"hue":"#ff0000"},{"saturation":"-90"},{"lightness":"0"},{"gamma":"1.00"},{"weight":"1"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#dfd8d4"},{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"visibility":"off"}]}]
        };
        var icons = {
            icon: 'wp-content/themes/base/dist/images/map-pin.svg'
        };
        // Get the HTML DOM element that will contain your map
        // We are using a div with id="map" seen below in the <body>
        var mapElement = document.getElementById('map');

        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(mapElement, mapOptions);

        // Let's also add a marker while we're at it
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(47.623043, 8.255099),
            map: map,
            icon: icons.icon,
            title: 'Snazzy!'
        });
    }




}(jQuery));



